import { render, staticRenderFns } from "./SortingList.vue?vue&type=template&id=2baa02ca&scoped=true&"
import script from "./SortingList.vue?vue&type=script&lang=ts&"
export * from "./SortingList.vue?vue&type=script&lang=ts&"
import style0 from "./SortingList.vue?vue&type=style&index=0&id=2baa02ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa02ca",
  null
  
)

export default component.exports